import { Link } from 'react-router-dom';

export default function VlogHero() {
  return (
    <section className="relative text-white pt-32 pb-20 overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/343a623d78fa924d24fc381a9b93cb90.jpg')`,
        }}
      />

      {/* Dark overlay matching blog style */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-950/85 via-amber-900/80 to-orange-900/85" />

      {/* Subtle radial glow */}
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            'radial-gradient(circle at 20% 50%, #E8B84B 0%, transparent 50%), radial-gradient(circle at 80% 20%, #E8B84B 0%, transparent 40%)',
        }}
      />

      <div className="relative container mx-auto px-4 z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Bald badge */}
          <div className="inline-flex items-center gap-2 bg-[#E8B84B]/15 border border-[#E8B84B]/30 text-[#E8B84B] rounded-full px-6 py-2 mb-6">
            <span className="text-2xl">🧑‍🦲</span>
            <span className="text-xs font-semibold uppercase tracking-widest">Two Founders, Zero Hair</span>
            <span className="text-2xl">🧑‍🦲</span>
          </div>

          {/* Main headline */}
          <h1 className="font-['Oswald'] text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 leading-tight">
            2 Bald Tires
          </h1>

          {/* Subheadline */}
          <p className="text-2xl md:text-3xl font-bold text-[#E8B84B] mb-6">
            Founders of Rockhound Auto
          </p>

          {/* Description */}
          <p className="text-base md:text-lg text-white/75 mb-8 max-w-3xl mx-auto leading-relaxed">
            Real talk about cars, dealer BS, and running an honest used car business.
            We're two bald guys who decided to fix the industry — one video at a time.
            No scripts, no polish, just the truth (and occasional dad jokes).
          </p>

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <a
              href="#videos"
              className="inline-flex items-center gap-2 bg-[#E8B84B] hover:bg-[#d4a43a] text-[#1C2B1E] font-bold px-8 py-4 rounded-full transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-xl"></i>
              Watch Latest Episode
            </a>
            <Link
              to="/broker-services"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-bold px-8 py-4 rounded-full transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-line text-xl"></i>
              Need Help Finding a Car?
            </Link>
          </div>

          {/* Fun stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl mx-auto">
            {[
              { value: '50+', label: 'Episodes' },
              { value: '0', label: 'Hairs Between Us' },
              { value: '100%', label: 'Unfiltered Truth' },
            ].map((stat) => (
              <div
                key={stat.label}
                className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl p-6"
              >
                <div className="font-['Oswald'] text-3xl font-bold text-[#E8B84B] mb-1">{stat.value}</div>
                <div className="text-sm font-semibold text-white/75">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom fade to page background */}
      <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-amber-50/30 to-transparent" />
    </section>
  );
}
